import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import DateRangeContext from "contexts/DateRangeContext";
import DeliveryGuySalesTable from "components/Tables/DeliveryGuySalesTable";
import { ClipLoader } from "react-spinners";

function DeliveryGuysSalesPage() {
  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [data, setData] = useState({});
  const [showLoader, setShowLoader] = useState(true);

  const refreshData = () => {
    setShowLoader(true);
    apiService
      .post(`api/v1/stores/${storeId}/delivery-guy-sales`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      })
      .then((resp) => {
        formatData(resp);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const formatData = (orders) => {
    let deliveryGuysOrders = {};
    for (let order of orders) {
      const userId = order.deliveredByUser.id;
      if (!_.has(deliveryGuysOrders, userId)) {
        deliveryGuysOrders[userId] = {
          name: order.deliveredByUser.name,
          orders: [],
        };
      }
      deliveryGuysOrders[userId].orders.push(order);
    }

    setData(deliveryGuysOrders);
  };

  useEffect(() => {
    if (!storeId || !dateRange) return;
    refreshData();
  }, [storeId, dateRange]);

  return (
    <>
      <Container fluid>
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          Object.keys(data).map((key) => (
            <Row key={key}>
              <Col xs={12} md={12}>
                <DeliveryGuySalesTable deliveryGuyName={data[key].name} data={data[key].orders} />
              </Col>
            </Row>
          ))
        )}
      </Container>
    </>
  );
}

export default DeliveryGuysSalesPage;
